/**
 * 音高相关的基础工具（供 pitch/ 目录内各模块共用，避免互相 import 成环）。
 */
export function midiToFreq(midi: number): number {
	return 440 * Math.pow(2, (midi - 69) / 12)
}

export function freqToMidi(freq: number): number {
	return Math.round(69 + 12 * Math.log2(freq / 440))
}

const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B']
export function midiToName(midi: number): string {
	return NOTE_NAMES[((midi % 12) + 12) % 12] + (Math.floor(midi / 12) - 1)
}

/**
 * MIDI → 简谱数字（固定 C 调：1=do … 7=si），带高低音点。
 *
 * 简谱记法：中音区（C4–B4，midi 60–71）不加点；每高一个八度在数字上方加一个
 * 「˙」，每低一个八度在数字下方加一个「·」。升降号（黑键）作为 `#`/`b` 前缀。
 *
 * 例：C4→`1`、C5→`1̇`、C3→`1̣`、F#4→`#4`。
 *
 * 注：这是「固定调」简谱（按 C 调键位标数字），与简谱本身的「首调」体系不同 ——
 * 校准页要告诉用户「弹键盘上哪个键」，必须用绝对音高对应的固定数字，否则同一
 * 个键在换了调号后数字会漂。
 */
export function midiToJianpu(midi: number): string {
	const pc = ((midi % 12) + 12) % 12  // 0=C … 11=B
	const octave = Math.floor(midi / 12) - 1  // C4=60 → 4

	// 半音映射：黑键用邻音的升降号（按简谱惯例优先升号，#4=升fa 等）
	const NATURAL: Record<number, string> = { 0: '1', 2: '2', 4: '3', 5: '4', 7: '5', 9: '6', 11: '7' }
	const SHARP: Record<number, string> = { 1: '#1', 3: '#2', 6: '#4', 8: '#5', 10: '#6' }
	const digit = NATURAL[pc] ?? SHARP[pc] ?? '?'

	// 八度点：中音区（octave 4）为基准，高音上加点、低音下加点
	const rel = octave - 4
	const dots = rel > 0
		? '̇'.repeat(rel)      // U+0307 上点（combining dot above）
		: rel < 0
			? '̣'.repeat(-rel)   // U+0323 下点（combining dot below）
			: ''
	return digit + dots
}
